import { useEffect, useState } from 'react';
import { Col, Row, Space, Spin } from 'antd';
import PropTypes from 'prop-types';
import { DownOutlined } from '@ant-design/icons';
import EVENT_NAME from 'utils/const';
import trackingService from 'services/trackingService';
import EbzTable from 'components/EbzTable';
import './CustomPayoutSegment.scss';
import Alert from 'components/Alert';
import EbzFilterGroup from 'components/EbzFilterGroup';
import payoutReportsAPI from 'services/payoutApi';
import EbzPopover from 'components/EbzPopover';
import EbzButton from 'components/EbzButton';
import BulkInvoiceModal from 'pages/NewPayoutReportListPage/InvoiceUploadModal/InvoiceUploadModal';
import IncompleteKycModal from 'pages/NewPayoutReportListPage/IncompleteKycModal/IncompleteKycModal';
import PayoutReportViewDetails from '../../PayoutReportTab/PayoutReportViewDetails';
import { getCustomBasedPayoutReport, CustomSearchArr, CustomPayoutReportfiltersArr } from './const';

function CustomPayoutSegment({ yearMonth }) {
  const [openModal, setModalOpen] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [customSummaryReports, setCustomSummaryReports] = useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [currentView, setCurrentView] = useState(null);
  // const [customFilters, setCustomFilters] = useState({});
  const [invoiceSummaryModal, setInvoiceSummaryModal] = useState(false);
  const [hasCustomPayout, setHasCustomPayout] = useState(false);
  const [requestRaiseModal, setRequestRaiseModal] = useState(false);
  const [kycModal, setKycModal] = useState(false);
  const [completeKyc, setCompleteKyc] = useState(false);
  const [pendingInvoiceIDs, setPendingInvoiceIDs] = useState([]);
  const [invoiceSummaryLoading, setInvoiceSummaryLoading] = useState(false);
  const [invoiceSummary, setInvoiceSummary] = useState([]);

  const fetchCustomPayoutReports = async (filtersCheck) => {
    setTableLoading(true);
    const request = {
      filters: filtersCheck,
      mandatory_check: {
        year_month: yearMonth
      },
      payout_report_key: 'CUSTOM'
    };
    const response = await payoutReportsAPI.getSceneriosBasedPayouts(request);
    if (!response?.success) {
      Alert('something went wrong', 'Please contact support team for this', 'error');
      setTableLoading(false);
    }
    setHasCustomPayout(response?.data?.fetch_payout_reports?.length > 0);
    setCustomSummaryReports(response?.data?.fetch_payout_reports);
    setCompleteKyc(response?.data?.is_kyc_complete);
    setTableLoading(false);
  };

  const clearFiltersCallBackfun = () => {
    setModalOpen(!openModal);
    fetchCustomPayoutReports();
  };

  const applyFiltersCallbackfunc = (checkFilters) => {
    setModalOpen(!openModal);
    const cleanedFilters = checkFilters.filter(
      (item) => item != null && Object.keys(item).length > 0
    );
    const mergedDict = cleanedFilters.reduce(
      (prevObj, currentObj) => ({ ...prevObj, ...currentObj }),
      {}
    );
    // setCustomFilters(mergedDict);
    fetchCustomPayoutReports(mergedDict);
  };

  const handleViewDetails = (record) => {
    setCurrentView(record);
    setOpenDrawer(!openDrawer);
  };

  const handleKycModal = () => {
    setKycModal(!kycModal);
  };

  const handleAcceptInvoice = (record) => {
    if (completeKyc === true) {
      setInvoiceSummaryModal(!invoiceSummaryModal);
      setPendingInvoiceIDs([record]);
      setInvoiceSummary([]);
    } else {
      handleKycModal();
    }
  };

  const handleRaiseRequestModal = (value) => {
    setRequestRaiseModal(!requestRaiseModal);
    console.log(value);
  };

  const handleUploadInvoice = async (payload) => {
    setInvoiceSummaryLoading(true);
    const response = await payoutReportsAPI.bulkInvoiceSubmit(payload, {
      'content-type': 'multipart/form-data'
    });

    if (response?.success) {
      handleRaiseRequestModal(true, 'Invoice');
      setInvoiceSummaryModal(false);
      setInvoiceSummaryLoading(false);
      fetchCustomPayoutReports();
    } else {
      setInvoiceSummaryLoading(false);
      Alert(response?.message, 'Please contact support team for this', 'error');
    }
  };

  const downloadInvoice = async (Uniqueid, Uniquekey) => {
    const response = await payoutReportsAPI.downloadS3Reports({
      unique_id: Uniqueid,
      unique_key: Uniquekey
    });

    if (response.success) {
      window.open(response.data.url);
    } else {
      console.log('something went wrong');
      Alert('something went wrong', 'Please contact support team for this', 'error');
    }
    trackingService.trackEvent(EVENT_NAME.BUTTON_CLICK, {
      name: 'Payout Report Downloaded',
      'unique-key': Uniquekey,
      unique_id: Uniqueid
    });
  };

  const scenerioPayoutColumns = getCustomBasedPayoutReport(
    handleViewDetails,
    handleAcceptInvoice,
    downloadInvoice
  );

  useEffect(() => {
    fetchCustomPayoutReports();
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
      <Row style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Col>
          <Space>
            <EbzPopover
              placement="bottomLeft"
              content={
                <EbzFilterGroup
                  searchParams={CustomSearchArr}
                  filters={CustomPayoutReportfiltersArr}
                  disableToday
                  apply={applyFiltersCallbackfunc}
                  clear={clearFiltersCallBackfun}
                />
              }
              open={openModal}
              onOpenChange={setModalOpen}
              trigger="click"
              overlayStyle={{
                width: '400px'
              }}
              overlayClassName="ebz-filters-popover"
            >
              <EbzButton size="large" className="ebz-filters-btn">
                Search & Filter
                <DownOutlined />
              </EbzButton>
            </EbzPopover>
          </Space>
        </Col>
      </Row>
      <Spin spinning={tableLoading}>
        <Row>
          <EbzTable
            columns={scenerioPayoutColumns}
            // eslint-disable-next-line no-underscore-dangle
            rowKey={(r) => `${r.title}_type`}
            dataSource={hasCustomPayout ? customSummaryReports : []}
            loading={false}
            pagination={false}
            isPagination={false}
            sticky
            size="medimum"
            thBgColor="#EEEDF1"
            scroll={hasCustomPayout && { x: 2000, y: 300, scrollToFirstRowOnChange: true }}
          />
        </Row>
      </Spin>
      <PayoutReportViewDetails
        viewMoreModal={openDrawer}
        handleViewDetails={handleViewDetails}
        currentView={currentView}
      />

      <BulkInvoiceModal
        pendingInvoiceIDs={pendingInvoiceIDs}
        invoiceSummaryModal={invoiceSummaryModal}
        handleDrawerClose={handleAcceptInvoice}
        payoutAcceptInvoice={handleUploadInvoice}
        setInvoiceSummaryLoading={setInvoiceSummaryLoading}
        invoiceSummaryLoading={invoiceSummaryLoading}
        invoiceSummary={invoiceSummary}
        setInvoiceSummary={setInvoiceSummary}
        yearMonth={yearMonth}
      />

      <IncompleteKycModal kycModal={kycModal} handleKycModal={handleKycModal} />
    </div>
  );
}

CustomPayoutSegment.propTypes = {
  yearMonth: PropTypes.string.isRequired
};

export default CustomPayoutSegment;
